import { EntityTypeIdEnum } from '@up/data';
import { GiftCardTransactionDto } from './giftCardTransaction.dto';

export class GiftCardTransactionRequestDto {
    transactions: GiftCardTransactionDto[];
    entityId: number;
    entityTypeId: EntityTypeIdEnum;
}
  